import { logger } from '@/lib';

export const logPrepareResidentialAddressInterstitialToFPTI = ({
  addressType,
  invalidAddressContingency = false,
}: {
  addressType: string;
  invalidAddressContingency: boolean;
}): void => {
  logger.fpti('prepare_residential_address_interstitial', {
    invalid_address_contingency: invalidAddressContingency,
    ...(addressType && {
      address_type: addressType,
    }),
    state_name: 'residential_address',
    transition_name: 'prepare_residential_address_interstitial',
  });
};

export const logResidentialAddressInterstitialClosedToFPTI = (): void => {
  const transactionName = 'residential_address_interstitial_closed';

  logger.fpti(transactionName, {
    state_name: 'residential_address',
    transition_name: transactionName,
  });
};

export const logResidentialAddressInterstitialSaveToFPTI = (): void => {
  const transactionName = 'residential_address_interstitial_save';

  logger.fpti(transactionName, {
    state_name: 'residential_address',
    transition_name: transactionName,
  });
};

export const logResidentialAddressInterstitialSaveAndContinueToFPTI =
  (): void => {
    const transactionName =
      'residential_address_interstitial_save_and_continue';
    logger.fpti(transactionName, {
      state_name: 'residential_address',
      transition_name: transactionName,
    });
  };
